import { render, staticRenderFns } from "./DocumentsLanding.vue?vue&type=template&id=908c9260&"
import script from "./DocumentsLanding.vue?vue&type=script&lang=js&"
export * from "./DocumentsLanding.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsLanding.vue?vue&type=style&index=0&id=908c9260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports